var OneTapSkin;
(function(OneTapSkin) {
    OneTapSkin["Primary"] = 'primary';
    OneTapSkin["Secondary"] = 'secondary';
})(OneTapSkin || (OneTapSkin = {}));
var OneTapContentId;
(function(OneTapContentId) {
    OneTapContentId[OneTapContentId[/**
   * Войти
   */ "SIGN_IN"] = 0] = "SIGN_IN";
    OneTapContentId[OneTapContentId[/**
   * Записаться
   */ "SIGN_UP"] = 1] = "SIGN_UP";
    OneTapContentId[OneTapContentId[/**
   * Получить
   */ "GET"] = 2] = "GET";
    OneTapContentId[OneTapContentId[/**
   * Открыть
   */ "OPEN"] = 3] = "OPEN";
    OneTapContentId[OneTapContentId[/**
   * Рассчитать
   */ "CALCULATE"] = 4] = "CALCULATE";
    OneTapContentId[OneTapContentId[/**
   * Заказать
   */ "ORDER"] = 5] = "ORDER";
    OneTapContentId[OneTapContentId[/**
   * Оформить заказ
   */ "PLACE_ORDER"] = 6] = "PLACE_ORDER";
    OneTapContentId[OneTapContentId[/**
   * Оставить заявку
   */ "SUBMIT_REQUEST"] = 7] = "SUBMIT_REQUEST";
    OneTapContentId[OneTapContentId[/**
   * Участвовать
   */ "PARTICIPATE"] = 8] = "PARTICIPATE";
})(OneTapContentId || (OneTapContentId = {}));

export { OneTapContentId, OneTapSkin };
